var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdraws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 335 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 73.5C5.64873 73.5 0.5 78.6487 0.5 85C0.5 91.3513 5.64873 96.5 12 96.5L12 73.5ZM331.132 93.1317C335.623 88.6407 335.623 81.3593 331.132 76.8683L257.946 3.68271C253.455 -0.808315 246.174 -0.808314 241.683 3.68271C237.192 8.17374 237.192 15.4551 241.683 19.9462L306.737 85L241.683 150.054C237.192 154.545 237.192 161.826 241.683 166.317C246.174 170.808 253.455 170.808 257.946 166.317L331.132 93.1317ZM12 96.5L323 96.5L323 73.5L12 73.5L12 96.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323 239.5C329.351 239.5 334.5 234.351 334.5 228C334.5 221.649 329.351 216.5 323 216.5L323 239.5ZM3.86827 219.868C-0.622758 224.359 -0.622757 231.641 3.86827 236.132L77.0538 309.317C81.5449 313.808 88.8263 313.808 93.3173 309.317C97.8083 304.826 97.8083 297.545 93.3173 293.054L28.2635 228L93.3173 162.946C97.8083 158.455 97.8083 151.174 93.3173 146.683C88.8262 142.192 81.5448 142.192 77.0538 146.683L3.86827 219.868ZM323 216.5L12 216.5L12 239.5L323 239.5L323 216.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraws);
export default __webpack_public_path__ + "static/media/withdraws.2544c68435f4b30fecc10f303b2aa05a.svg";
export { ForwardRef as ReactComponent };